import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useAppDispatch } from '../../../app/hooks'
import { setCurrentModal } from '../../../app/reducers/modal/modal.slice'
import { ModalsTypesEnum } from '../../../app/reducers/modal/modal.types'
import { GlowingIcon } from '../../UI/GlowingIcon'
import Container from '../Container/Container'
import Location from '../Location/Location'
import SocialLinks from '../SocialLinks/SocialLinks'
import Title from '../Title/Title'
import styles from './Footer.module.scss'
import { FooterProps } from './Footer.types'

export default function Footer(props: FooterProps) {
	const translation = useTranslation()
	const { t, i18n } = translation
	const dispatch = useAppDispatch()

	const handleDownload = () => {
		const fileUrl =
			i18n.language === 'ru'
				? '/Технологии_будущего_Rus.pdf'
				: '/Sairus_Pres_Eng.pdf'

		const fileName =
			i18n.language === 'ru'
				? 'Технологии_будущего_Rus.pdf'
				: 'Sairus_Pres_Eng.pdf'

		const link = document.createElement('a')
		link.href = fileUrl
		link.download = fileName
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}
	return (
		<footer className={styles.footer} id='contacts'>
			<Container>
				<div className={styles.footer__content}>
					<Location />
					<div className={styles.footer__questions}>
						<div className='text-s'>{t('landing.footer.p1')}</div>
						<div>
							<h3>{t('landing.footer.help')}</h3>
							<span className='text-xs'>
								{t('landing.footer.p2')}
								<a
									className={styles.footer__mailto_support}
									href='mailto:support@sairus.net'
								>
									support@sairus.net
								</a>
							</span>
						</div>
						<div>
							<h3>{t('landing.footer.partnertions')}</h3>
							<span className='text-xs'>
								{t('landing.footer.p3')}
								<a
									className={styles.footer__mailto_info}
									href='mailto:w.branson@sairus.net'
								>
									w.branson@sairus.net
								</a>
							</span>
						</div>
						<div className={styles.footer__confidential}>
							<GlowingIcon
								name='safeguard'
								className={styles.footer__safeguard}
								blurRadius={10}
							/>
							<span className='text-xs'>{t('landing.footer.p4')}</span>
						</div>
					</div>
				</div>
				<div className={styles.copy_links}>
					<div className={styles.footer__links}>
						<div className={styles.footer__links_links}>
							<div className={styles.mobile_links}>
								<div className={styles.links_box}>
									<a href='/#tech' className={styles.footer__links_link}>
										{t('landing.footer.tech')}
									</a>

									<button
										onClick={handleDownload}
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
									>
										{t('landing.footer.presentation')}
									</button>
									<span
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
										onClick={() =>
											dispatch(setCurrentModal(ModalsTypesEnum.CONF))
										}
										style={{ cursor: 'pointer' }}
									>
										{t('landing.footer.conf')}
									</span>
									<Link
										to='/charity'
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
									>
										{t('landing.footer.charity')}
									</Link>
								</div>
								<div className={styles.links_box}>
									<a href='/#faq' className={styles.footer__links_link}>
										{t('landing.footer.faq')}
									</a>
									<a href='/#about' className={styles.footer__links_link}>
										{t('landing.footer.about')}
									</a>
									<a href='/#news' className={styles.footer__links_link}>
										{t('landing.footer.news')}
									</a>
									<a href='/#partners' className={styles.footer__links_link}>
										{t('landing.footer.partners')}
									</a>
								</div>
							</div>

							<div className={styles.footer__logo}>
								<Title className={styles.footer_logo_img} />
								<SocialLinks className={styles.social_tablet} />
							</div>
							<SocialLinks className={styles.social_mobile} />
							<div className={styles.pc_links}>
								{' '}
								<div className={styles.links_box}>
									<a href='/#partners' className={styles.footer__links_link}>
										{t('landing.footer.partners')}
									</a>
									<a href='/#tech' className={styles.footer__links_link}>
										{t('landing.footer.tech')}
									</a>
								</div>
								<div className={styles.links_box}>
									<a href='/#news' className={styles.footer__links_link}>
										{t('landing.footer.news')}
									</a>
									<button
										onClick={handleDownload}
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
									>
										{t('landing.footer.presentation')}
									</button>
								</div>
								<div className={styles.links_box}>
									{' '}
									<a href='/#faq' className={styles.footer__links_link}>
										{t('landing.footer.faq')}
									</a>
									<a href='/#about' className={styles.footer__links_link}>
										{t('landing.footer.about')}
									</a>
								</div>
								<div className={styles.links_box}>
									<span
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
										onClick={() =>
											dispatch(setCurrentModal(ModalsTypesEnum.CONF))
										}
										style={{ cursor: 'pointer' }}
									>
										{t('landing.footer.conf')}
									</span>
									<Link
										to='/charity'
										className={[
											styles.footer__links_link,
											styles.mobileHidden,
										].join(' ')}
									>
										{t('landing.footer.charity')}
									</Link>
								</div>
							</div>

							<div
								className={[
									styles.footer__social_container,
									styles.mobileHidden,
								].join(' ')}
							>
								<SocialLinks className={styles.social_pc} />
							</div>
						</div>
					</div>
					<div className={[styles.footer__copyright_pc].join(' ')}>
						<p className='text-xs'>
							{t('all-right-reserved')}. Copyright © 2023 SAIRUS LTD
						</p>
					</div>
				</div>
				<div className={styles.footer__copyright_mobile}>
					<p className='text-xs'>
						{t('all-right-reserved')}. Copyright © 2023 SAIRUS LTD.{' '}
					</p>
				</div>
			</Container>
		</footer>
	)
}
